import React from 'react';
import '../../styles/principal/copyright.css';

function Copyright() {
    return (
        <div className='div-copyright'>
            <span className='span-copyright'><a className='a-copyright' href='https://www.centronacionaldeconsultoria.com/'>Copyright © Centro Nacional de Consultoría (CNC)</a> {new Date().getFullYear()}</span>
        </div>
    );
}

export default Copyright;